var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGsheetsLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #22a466;\n      }\n\n      .cls-2 {\n        fill: #1a8e5a;\n      }\n\n      .cls-3 {\n        fill: #8eceaf;\n      }\n\n      .cls-4 {\n        fill: #fff;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M347.5,377c0,12.8-10.7,23-23.7,23H76.2c-13.1,0-23.7-10.4-23.7-23V23.2c0-12.8,10.7-23,23.7-23H235.4L347.5,112Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "247.7 109.2 347.5 202 347.2 111.9 247.7 109.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M347.5,111.9H258.9c-13.1,0-23.7-10.4-23.7-23V0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M209.5,307.5v-20h48.2v20Zm-67.4-20h48.2v20H142.1Zm48.4-13.8H142.3V252.1h48.2Zm0-58.5v23H142.3v-23Zm19,37h48.2v21.5H209.5Zm48.2-14H209.5v-23h48.2ZM123.3,196.6V326.2H276.9V196.6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsheetsLogo);
export default __webpack_public_path__ + "static/media/gsheets-logo.27e90123edd0c4fabe7beb90f25a1e8e.svg";
export { ForwardRef as ReactComponent };